// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__14Yly","logo":"styles_logo__2KPEG","login__Link__Item":"styles_login__Link__Item__2xILB","login__Link":"styles_login__Link__2ZGh9"};